import React from 'react'

interface ReviewStatisticsProps {
  reviewedToday: number
  totalDue: number
  dailyTarget: number
  percentageComplete: number
}

export function ReviewStatistics({
  reviewedToday,
  totalDue,
  dailyTarget,
  percentageComplete,
}: ReviewStatisticsProps) {
  const remaining = Math.max(0, dailyTarget - reviewedToday)
  const isComplete = reviewedToday >= dailyTarget

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Today's Progress</h2>

      {/* Progress Bar */}
      <div className="mb-6">
        <div className="flex justify-between text-sm text-gray-600 mb-2">
          <span>Daily Goal</span>
          <span>
            {reviewedToday} / {dailyTarget} cards
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-4">
          <div
            className={`h-4 rounded-full transition-all duration-500 ${
              isComplete ? 'bg-success-600' : 'bg-primary-600'
            }`}
            style={{ width: `${Math.min(100, percentageComplete)}%` }}
          />
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-3 gap-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-primary-600">{reviewedToday}</div>
          <div className="text-xs text-gray-600">Reviewed</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-orange-600">{totalDue}</div>
          <div className="text-xs text-gray-600">Due Today</div>
        </div>
        <div className="text-center">
          <div className={`text-2xl font-bold ${isComplete ? 'text-success-600' : 'text-gray-600'}`}>
            {remaining}
          </div>
          <div className="text-xs text-gray-600">Remaining</div>
        </div>
      </div>

      {/* Completion Message */}
      {isComplete && (
        <div className="mt-4 p-3 bg-success-50 border border-success-200 rounded-lg text-center">
          <span className="text-success-700 font-medium">
            🎉 Daily goal complete! Keep going for extra practice.
          </span>
        </div>
      )}
    </div>
  )
}
